
import { mapState, mapMutations } from 'vuex'
import { cartItemToAnalyticsItem, cartItemToGA4Item } from '~/utils/helpers'
import analytics from '~/mixins.js/analytics'

export default {
  layout: 'checkout',
  transition: 'page',
  mixins: [analytics],
  data () {
    return {
      submitFormState: {
        isLoading: false
      }
    }
  },
  head () {
    return {
      title: 'infoDiagram - Order',
      bodyAttrs: {
        class: 'page-cart'
      }
    }
  },
  computed: {
    ...mapState({
      cart: state => state.checkout.cart,
      wishlist: state => state.favourites.wishlist,
      preview: state => state.checkout.modals.preview
    }),
    canProceed () {
      const specialOffersCount = this.cart.filter(item => item.specialOffer).length
      return this.cart.length > 0 && specialOffersCount < this.cart.length
    },
    diagramIds () {
      return this.cart.map(item => item.diagram.id)
    }
  },
  async created () {
    if (process.client) {
      await this.checkForBundle(this)
    }
  },
  async mounted () {
    await this.$store.dispatch(
      'checkout/setItemPreview',
      {
        visible: false,
        diagram: null,
        $backend: this.$backend
      }
    )
  },
  methods: {
    proceed () {
      this.submitFormState.isLoading = true
      this.$gtag.event(
        'begin_checkout',
        {
          items: this.cart.map((item, index) => ({
            ...cartItemToAnalyticsItem(item, index)
          }))
        }
      )
      this.$gtag.event(
        'begin_checkout',
        {
          send_to: [
            this.$config.ga4TrackingId
          ],
          items: this.cart.map((item, index) => ({
            ...cartItemToGA4Item(item, index)
          }))
        }
      )
      this.$router.push('/checkout/data')
    },
    ...mapMutations('checkout', ['setBundle']),
    checkForBundle: async ({ $route, $backend, setBundle, $store, $gtag, $matomo, $bing, $toast, trackEvent }) => {
      const { bundle: slug } = $route.query
      if (!slug) {
        setBundle(null)
        return
      }
      $toast.info('Looking up the bundle...')
      trackEvent('bundle', 'lookup', slug)
      try {
        const {
          results,
          count
        } = await $backend.bundles.get({ slug })
        if (count === 1) {
          $toast.clear()
          $toast.success('Bundle found!', { duration: 3000 })
          trackEvent('bundle', 'found', slug)
          const bundle = results[0]
          for (const diagram of bundle.diagrams) {
            await $store.dispatch(
              'checkout/addDiagramToCart',
              {
                diagram,
                $gtag,
                $matomo,
                $bing
              }
            )
            setBundle(bundle)
          }
        } else {
          trackEvent('bundle', 'not_found', slug)
          $toast.clear()
          $toast.error("Couldn't find. Maybe it is too late. Contact us if you think it's a mistake.")
          setBundle(null)
        }
      } catch (e) {
        trackEvent('bundle', 'error')
        $toast.clear()
        $toast.error("Error looking for bundle. Contact us if you think it's a mistake.")
        console.log('Error fetching bundle', e)
        setBundle(null)
      }
    }
  }
}
